/** Available locales */
export enum I18nLocalesEnum {
  /** English (United States) */
  EN_US = 'en-US',
  /** Russian (Russian Federation) */
  RU_RU = 'ru-RU',
}
